"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.WorkflowPage = void 0;
var base_1 = require("./base");
var basic_1 = require("./basic");
var header_1 = require("./components/header");
exports.WorkflowPage = {
    Basic: basic_1.BasicWorkflow,
    Base: base_1.BaseWorkflowLayout,
    Header: header_1.WorkflowHeader,
};
